<template>
  <div>
    <div id="login">
      <a @click="redirectBackIfPresent()" class="no-deco back-button-login cursor-pointer" :class="isPhone ? 'raleway-semi-p14 px-3 mb-2' : 'raleway-semi-p24 mb-5'"> < Retour </a>
      <div class="content">
        <div class="content-form">
          <div class="header-modal headline">
            <p :class="isPhone ? 'merriweather-reg-30 pt-3' : 'merriweather-reg-40'">Rejoignez le Club Hortense</p>
          </div>
          <div class="form-signup raleway-reg-p15" :class="isPhone ? 'pt-2' : 'pt-5'">
            <p style='color: red;' v-if='text'>{{ text }}</p>
            <div class="form-item">
              <div class="label-row">
                <label for="last_name" :class="isPhone ? 'raleway-medi-p14' : 'raleway-medi-p25'">Nom*</label>
                <span class="required-text raleway-reg-p15">( * champs obligatoires )</span>
              </div>
              <input v-model="userInfo.last_name" type="text" />
            </div>
            <div class="form-item">
              <label for="first_name" :class="isPhone ? 'raleway-medi-p14' : 'raleway-medi-p25'">Prénom*</label>
              <input v-model="userInfo.first_name" type="text" />
            </div>
            <div class="form-item">
              <label for="birthday" :class="isPhone ? 'raleway-medi-p14' : 'raleway-medi-p25'">Date de naissance</label>
              <input v-model="userInfo.birthday" type="date" data-date-inline-picker="true" />
            </div>
            <div class="form-item">
              <label for="email" :class="isPhone ? 'raleway-medi-p14' : 'raleway-medi-p25'">Email*</label>
              <input v-model="userInfo.email" type="text" />
            </div>
            <div class="form-item">
              <label for="password" :class="isPhone ? 'raleway-medi-p14' : 'raleway-medi-p25'">Mot de passe*</label>
              <input v-model="userInfo.password" type="password" />
            </div>
            <div class="form-item">
              <label for="password_confirmation" :class="isPhone ? 'raleway-medi-p14' : 'raleway-medi-p25'">Confirmation du mot de passe*</label>
              <input v-model="userInfo.password_confirmation" type="password" />
            </div>
            <div class="form-item newsletter">
              <input type="checkbox" id="newsletter" value="newsletter" v-model="checkedItems" />
              <label for="newsletter" :class="isPhone ? 'raleway-reg-p15' : 'raleway-reg-p20'" class="text-gray">
                J'accepte la <a :href="'/pages/privacy_policy/'" class="link-hortense" target="_blank">politique de confidentialité</a>.
              </label>
            </div>
            <div class="form-item newsletter">
              <input type="checkbox" id="newsletter_1" value="newsletter_1" v-model="checkedItems" />
              <label for="newsletter_1" :class="isPhone ? 'raleway-reg-p15' : 'raleway-reg-p20'" class="text-gray">
                J'accepte de recevoir les newsletters d'Hortense.
              </label>
            </div>
            <button @click="UserBasicInfo" class="hortense-btn-primary" :class="isPhone ? 'raleway-bold-p14' : 'raleway-bold-p25  mt-4'">S'INSCRIRE</button>
          </div>
        </div>
        <div class="social-connection divider">
          <p class="mt-2 mx-4" :class="isPhone ? 'raleway-reg-p15' : 'raleway-reg-p20'">ou</p>
        </div>
        <div class="social-connection-btn" :class="isPhone ? 'pt-2' : 'pt-4'">
          <div class="social-btn">
            <img src="https://hortense-vue.s3.eu-west-3.amazonaws.com/static/google.png" v-set-alt>
            <a :href="'/users/auth/google_oauth2'" :class="isPhone ? 'raleway-semi-p15' : 'raleway-semi-p20'">S'inscrire avec Google</a>
          </div>
        </div>
        <div class="social-connection-btn">
          <div class="social-btn fb-social-btn">
            <img src="https://hortense-vue.s3.eu-west-3.amazonaws.com/static/facebook.png" v-set-alt>
            <a :href="'/users/auth/facebook'" :style="'color: #FFFFFF;'" :class="isPhone ? 'raleway-semi-p15' : 'raleway-semi-p20'">S'inscrire avec Facebook</a>
          </div>
        </div>
      </div>
    </div>
    <div class="promo-page pt-5" :class="isPhone ? '' : 'px-5'">
      <p class=" text-center" :class="isPhone ? 'merriweather-reg-24' : 'merriweather-reg-40'">Voyagez comme un invité privilégié avec le club hortense</p>
      <p class="text-center" :class="isPhone ? 'raleway-reg-p15' : 'merriweather-light-24'">
        Inscrivez-vous à notre programme de fidélité et profitez de services exclusifs pour rendre votre séjour unique.
      </p>
      <div class="slider-wrapper pt-4 position-relative">
        <div class="d-flex flex-row flex-nowrap" id="offers-scroller" style="overflow: scroll; overflow-y: hidden">
          <div v-for="(offer, index) in visibleOffers" :key="index" class="offer">
            <div class="zoom-img-container">
              <img :src="offer.image" :alt="offer.title" class="offer-image zoom-img" />
            </div>
            <p class="offer-title" :class="isPhone ? 'raleway-semi-p15' : 'raleway-bold-p16'">{{ offer.title }}</p>
          </div>
        </div>
        <div class="previous-slide-button" @click="scroll_left">
          <button class="nav-button left mb-5">
            &lt;
          </button>
        </div>
        <div class="next-slide-button" @click="scroll_right">
          <button class="nav-button right mb-5">
            &gt;
          </button>
        </div>
      </div>
      <p class="text-center pt-4 address-p" :class="isPhone ? 'raleway-reg-p15' : 'raleway-reg-p15'">
        Chaque adresse de notre sélection est minutieusement choisie pour vous offrir un accueil d’exception. Réservez dès maintenant sur notre site et profitez d'une expérience unique.
      </p>
      <button @click="visitLink('/programme-fidelite-club-hortense')" class="cta-button mt-4">
        EN SAVOIR PLUS
      </button>
      <p class=" disclaimer pt-4" :class="isPhone ? 'raleway-reg-p8' : 'raleway-reg-p15'">
        *Chaque hébergement propose des services exclusifs soigneusement sélectionnés. Consultez la page dédiée à l’hébergement pour découvrir les offres disponibles. Les détails peuvent varier d’un établissement à l’autre.
      </p>
    </div>
  </div>
</template>

<script>
import fetcher from "packs/shared/api.js";

export default {
  name: "SignUpForm",
  props: {
    redirectUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      userInfo: {
        first_name: "",
        last_name: "",
        birthday: "",
        email: "",
        password: "",
        password_confirmation: "",
        newsletter: false,
      },
      referralCode: null,
      currentStartIndex: 0,
      offers: [
        { title: "Massage offert", image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Massage+gratuit+service+exclusif+Hortense.jpg" },
        { title: "Petit déjeuner offert", image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Petit+de%CC%81j+offert+service+exclusif+Hortense.jpg" },
        { title: "Dîner offert", image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Di%CC%82ner+offert+service+exclusif+Hortense.jpg"},
        { title: "Surclassement de chambre", image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Surclassement+de+chambre+service+exclusif+Hortense.jpg" },
        { title: "Bouteille de champagne" ,image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Bouteille+de+champagne+service+exclusif+Hortense.jpg" },
        { title: "Dégustation de vin", image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/De%CC%81gustation+de+vin+service+exclusif+Hortense.jpg" },
        { title: "Verre de bienvenue", image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Verre+de+bienvenue+service+exclusif+Hortense.jpg" }
      ],
      checkedItems: [],
      showModal: false,
      text: null,
      currentStartIndex: 0,
    };
  },
  computed: {
    visibleOffers() {
      return this.offers;
    },
    isPhone() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
    },
    itemsPerPage() {
      return this.isPhone ? 2 : 4;
    }
  },
  methods: {
    redirectBackIfPresent() {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = '/';
      }
    },
    visitLink(link) {
      window.open(link, '_blank');
    },
    formatDate(date) {
      if (!date) return '';
      const set = new Date(date);
      let getDate = set.getDate().toString();
      if (getDate.length === 1) {
        getDate = "0" + getDate;
      }
      let getMonth = (set.getMonth() + 1).toString();
      if (getMonth.length === 1) {
        getMonth = "0" + getMonth;
      }
      let getYear = set.getFullYear().toString();
      return getYear + "-" + getMonth + "-" + getDate;
    },
    validateEmail(email) {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    },
    async UserBasicInfo() {
      if (!this.validateEmail(this.userInfo.email)) {
        this.text = "Email incorrect";
        return;
      }
      if (this.userInfo.password.length < 12) {
        this.text = "Le mot de passe doit contenir 12 caractères minimum ";
        return;
      }
      if (this.userInfo.password !== this.userInfo.password_confirmation) {
        this.text = "Le mot de passe saisi doit être identique";
        return;
      }
      if (this.checkedItems.includes("newsletter")) {
        this.userInfo.newsletter = true;
      }
      try {
        const payload = {
          user: {
            first_name: this.userInfo.first_name,
            last_name: this.userInfo.last_name,
            birthday: this.formatDate(this.userInfo.birthday),
            email: this.userInfo.email,
            password: this.userInfo.password,
            password_confirmation: this.userInfo.password_confirmation,
            newsletter: this.userInfo.newsletter,
          },
        };
        if (this.referralCode) {
          payload.referred_by_code = this.referralCode;
        }
        const response = await fetcher.post("/users/", payload);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'sign_up',
          method: 'email_password',
        });
        window.location.replace(this.redirectUrl)
      } catch (e) {
        this.text = "Cet email est déjà utilisé";
      }
    },
    autoScroll() {
      const scroller = document.getElementById('offers-scroller');
      if (!scroller) return;
      const step = 1;
      let maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;

      const frame = () => {
        if (scroller.scrollLeft >= maxScrollLeft) {
          scroller.scrollLeft = 0;
          maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;
        } else {
          scroller.scrollLeft += step;
        }
        requestAnimationFrame(frame);
      }
      frame();
    },
    scroll_left() {
      let content = document.querySelector("#offers-scroller");
      content.scrollLeft -= 220;
    },
    scroll_right() {
      let content = document.querySelector("#offers-scroller");
      content.scrollLeft += 220;
    }
  },
  mounted() {
    this.autoScroll();
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (ref) {
      this.referralCode = ref;
    }
  }
}
</script>

<style lang="scss" scoped>
// Copy the CSS from LoginForm.vue for full parity
.form-input {
  border: 1px solid black;
  &:focus {
    outline: none;
  }
}
#login {
  height: auto;
  display: grid;
  background: url("https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/inscription-hortense.jpeg");
  background-size: cover;
  padding: 135px 0;
  @media  screen and (max-width: 768px) {
    padding: 100px 40px 23px 41px;
  }
}
.headline {
  text-align: center;
  line-height: 1.2;
  word-spacing: 2px;
}
.social-btn {
  border: 1px solid #707070;
  width: 427px;
  @media screen and (max-width: 768px) {
    width: 97%;
  }
}
.fb-social-btn {
  background: #3B5998;
}
.divider {
  display: flex;
  align-items: center;
  text-align: center;
  width: 75%;
  margin-left: 15%;
  position: relative;
  @media screen and (max-width: 768px) {
    width: 100% !important;
    margin-left: 0 !important;
  }
}
#login .hortense-btn-primary-creer{
  width: 427px;
  height: 88px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  align-items: center;
  color: white;
  text-decoration: none;
  background-color: #3B6152;
  padding: 16px 36px;
  text-transform: uppercase;
  margin-left: auto;
  margin-right: auto;
  font-size: 13px;
  font-family: $Raleway;
  font-weight: 700;
  @media screen and (max-width: 768px) {
    width: 85%;
    height: 46px;
    font-size: 13px;
    padding: 0 1rem;
  }
  @media screen and (max-width: 480px) {
    width: 100%;
    height: 46px;
    font-size: 14px;
    padding: 0;
  }
}
.divider::before,
.divider::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #707070;
  margin: 0 10px;
}
.divider span {
  color: black;
}
.vous {
  text-align: center;
  color: #090808;
  opacity: 1;
}
#login .social-connection-btn {
  @media screen and (max-width: 768px) {
    padding: 0 1rem;
  }
  @media screen and (max-width: 480px) {
    width: 100%;
    padding: 0;
  }
}
#login .social-connection-btn .social-btn a {
  margin: 11px;
  letter-spacing: 0px;
  font-family: $Raleway;
  font-size: 20px;
  @media screen and (max-width: 768px) {
    font-size: 15px;
  }
}
#login .social-connection-btn .social-btn img {
  width: 40px;
  height: 40px;
  @media screen and (max-width: 768px) {
    width: 36px;
    height: 36px;   
  }
}
#login .social-connection-btn .social-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 36px;
  width: 427px;
  height: 60px;
  border: 1px solid #707070;
  box-shadow: unset;
  border-radius: unset;
  @media screen and (max-width: 768px) {
    width: 97%;
    padding: 0;
  }
}
#login .social-connection-btn{
  margin-bottom: 1rem;
  @media screen and (max-width: 768px) {
    margin-bottom: 8px;
  }
}
#login .social-connection {
  display: flex;
  flex-direction: row;
  width: 70%;
  margin-left: 15%;
  @media screen and (max-width: 768px) {
    padding: 0;
    margin: unset;
    width: 97% !important;
  }
}
#login .form-signup {
  width: 100%;
  max-width: 100%;
  padding: 0 1rem;
  box-sizing: border-box;
  @media screen and (max-width: 480px) {
    padding: 0; 
  }
}
#login .form-signup .form-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
  width: 675px;

  @media screen and (max-width: 768px) {
    width: 100%;
    margin-bottom: 10px;
  }
}
#login .form-signup label {
  margin-bottom: 0.5rem;
  white-space: normal;
  word-break: break-word;
  color: #333;
}
#login .form-signup input {
  padding: 0.75rem;
  border: 1px solid #090808;
  box-sizing: border-box;
  width: 675px;
  @media screen and (max-width: 768px) {
    width: 100%;
    height: 44px;
    padding-left: 4%;
    padding-right: 4%;
  }
}
.content {
  width: 925px !important;
  @media screen and (max-width: 768px) {
    width: 100% !important;
    overflow-y: hidden;
  }
}
.content-form {
  padding-bottom: 1rem !important;
  @media screen and (max-width: 768px) {
    padding: 0 !important;
    height: auto !important;
  }
}
.promo-page {
  max-width: 1968px;
  background: #f7f7f7;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
}
.description, .subtext {
  color: #090808;
  margin-bottom: 20px;
}
.disclaimer {
  color: #090808;
  text-align: start;
}
.offers {
  display: flex;
  justify-content: start;
  align-items: center;
  flex-wrap: nowrap;
  gap: 20px;
  overflow: hidden;
}
.offer {
  flex: 0 0 auto;
  width: fit-content;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 10px;

  @media screen and (max-width: 768px) {
    padding: 0;
  }

  img {
    @media screen and (max-width: 768px) {
      width: 250px;
      height: 300px;
    }
  }
}
.slider-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  overflow: hidden;
  margin: 20px 0;
  background: #F7F7F7 0% 0% no-repeat padding-box;
  height: unset;
  padding: 0 60px;

  @media screen and (max-width: 768px) {
    padding: 0 50px;
  }

  @media screen and (max-width: 480px) {
    padding: 0 25px;
    gap: 5px;
  }
}
.previous-slide-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 10px;
  z-index: 10;

  @media screen and (max-width: 768px) {
    left: 5px;
  }

  @media screen and (max-width: 480px) {
    left: 2px;
  }

  button {
    font-size: 3.5rem;
    color: #707070;
    border: none;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    @media screen and (max-width: 768px) {
      font-size: 2rem;
      width: 40px;
      height: 40px;
    }

    @media screen and (max-width: 480px) {
      font-size: 1.5rem;
      width: 35px;
      height: 35px;
    }

    &:hover {
      color: #3B6152;
    }
  }
}
.next-slide-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  z-index: 10;

  @media screen and (max-width: 768px) {
    right: 5px;
  }

  @media screen and (max-width: 480px) {
    right: 2px;
  }

  button {
    font-size: 3.5rem;
    color: #707070;
    border: none;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    @media screen and (max-width: 768px) {
      font-size: 2rem;
      width: 40px;
      height: 40px;
    }

    @media screen and (max-width: 480px) {
      font-size: 1.5rem;
      width: 35px;
      height: 35px;
    }

    &:hover {
      color: #3B6152;
    }
  }
}
.offer-image {
  width: 360px;
  height: 428px;
  max-width: 100%;
  object-fit: cover;

  @media screen and (max-width: 768px) {
    width: 100%;
    height: 206px;
    max-width: calc(100% - 20px);
  }

  @media screen and (max-width: 480px) {
    max-width: calc(100% - 10px);
  }
}
.offer-title {
  margin-top: 10px;
  text-transform: uppercase;
  height: 50px;
}
.cta-button {
  background-color: #3B6152;;
  color: white;
  padding: .8rem 2rem;
  border: none;
  cursor: pointer;
  margin-top: 20px;
  text-align: center;
  font-family: $Raleway;
  font-weight: 700;
  font-size: 13px;
  text-decoration: none;
  transition: background-color .3s;

  @media screen and (max-width: 768px) {
    width: 325px;;
    height: 46px;
    padding: 0;
    font-size: 14px;
  }
}
.learn-more {
  color: #090808;
  text-decoration: underline;
  font-size: 1rem;
  cursor: pointer;
  margin-top: 10px;
}
.learn-more:hover {
  text-decoration: underline;
}
.link-hortense {
  color: #6D6A6A;
  font-family: "Raleway";
  font-weight: 600;
  font-size: 20px;

  @media screen and (max-width: 768px) {
    font-size: 15px;
  }
}
.address-p {
  padding-left: 15%;
  padding-right: 15%;

  @media screen and (max-width: 768px) {
    padding-left: 5%;
    padding-right: 5%;
  }
}
.hortense-btn-primary {
  width: 427px !important;
  @media screen and (max-width: 768px) {
    width: 97% !important;
  }
}
.back-button-login {
  padding-left: 140px;
}

.text-gray {
  color: #6D6A6A;
}

.label-row {
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    color: #707070;
  }
}

input[type=checkbox]:checked + label::before {
  background-color: #3B6152;
}
</style>